import { ENTITY_TYPES } from '@sales-center/common'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { APIError, get, put } from '../services/crud'
import {
  IEntityFormSetting,
  IEntityFormSettingsOptionsInput,
  IEntityFormSettingsToggleInput,
} from './typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.entityFormSettings.entityFormSettings}`

export const getAllEntityFormSettings = createAsyncThunk<
  IEntityFormSetting[],
  ENTITY_TYPES,
  { rejectValue: APIError }
>('entityFormSettings/getAll', async (entityType: ENTITY_TYPES, thunkApi) => {
  const response = await get(
    `${baseUrl}${
      entityType == ENTITY_TYPES.Lead
        ? ServiceConfig.entityFormSettings.leadFormSettings
        : ServiceConfig.entityFormSettings.opportunityFormSettings
    }`,
  )
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const toggleRequired = createAsyncThunk<
  number,
  IEntityFormSettingsToggleInput,
  { rejectValue: APIError }
>('entityFormSettings/toggleRequired', async (data, thunkApi) => {
  const response = await put(`${baseUrl}/toggleRequired`, data)
  if (response.ok) return data.id
  return thunkApi.rejectWithValue(await response.json())
})

export const toggleActive = createAsyncThunk<
  number,
  IEntityFormSettingsToggleInput,
  { rejectValue: APIError }
>('entityFormSettings/toggleActive', async (data, thunkApi) => {
  const response = await put(`${baseUrl}/toggleActive`, data)
  if (response.ok) return data.id
  return thunkApi.rejectWithValue(await response.json())
})

export const updateOptions = createAsyncThunk<
  IEntityFormSettingsOptionsInput,
  IEntityFormSettingsOptionsInput,
  { rejectValue: APIError }
>('entityFormSettings/updateOptions', async (data, thunkApi) => {
  const response = await put(`${baseUrl}/options`, data)
  if (response.ok) return data
  return thunkApi.rejectWithValue(await response.json())
})
